import MonthSavingCool from "./Month-saving-with-cool-access";

const MonthlySaving = () => {
  return (
    <div>
      <MonthSavingCool></MonthSavingCool>
    </div>
  );
};

export default MonthlySaving;
